<template>
    <div :class="wide ? 'lg:col-span-2' : ''">
        <dt class="text-sm font-medium text-gray-500">
            <slot name="label">{{ label }}</slot>
        </dt>
        <dd class="mt-1 text-sm text-gray-900 w-full">
            <slot>
                <span class="whitespace-pre-wrap" v-if="raw" v-html="value || '—'"></span>
                <span class="whitespace-pre-wrap" v-else="raw" v-text="value || '—'"></span>
            </slot>
        </dd>
    </div>
</template>

<script>
export default {
    props: {
        label: String,
        value: String|Number,
        wide: Boolean,
        raw: Boolean
    },
}
</script>
